module.exports = __webpack_public_path__ + "img/组5393@2x.7feadd2d.png";